export const MAX_SESSIONS_PER_USER = 3
